import { Input } from 'cd-eft/components/common/Input';
import { observer } from 'mobx-react';
import React, { Fragment, useEffect, useRef } from 'react';
import { FormulaBanner } from '../Common/FormulaBanner';
import {
  ResultsContainer,
  ImageContainer,
  DescriptionContainer,
  InputContainer,
  FormulaPrintModalContainer
} from '../template/FormulaFormTemplates';
import { Loader } from 'cd-eft/components/common/LoadingSpinner/LoadingSpinner';
import { CubeVM } from './CubeVM';
import { RadioGroup } from 'cd-eft/components/common/RadioGroup';
import pdfLogo from 'cd-eft/assets/images/pdf-blue.svg';

const CubeComponent = (props) => {
  const vm = useRef(new CubeVM(props)).current;
  useEffect(() => {
    // on initial render, load form data - desc, img, help link
    vm.getFormData(`${props.section}_${props.title}_${props.id}`);
  }, []);
  return (
    <Fragment>
      <FormulaBanner title={vm.formulaTitle} help={vm.bannerHelpLink} />
      <div className="formula-content row ">
        <InputContainer computeCallback={() => vm.computeCube()} printCallback={() => vm.launchAndExport()} isLoading={vm.isLoading} disableCompute={vm.disableComputeBtn} disablePrint={!vm.hasResults || vm.isLoading || vm.disablePrintBtn}>
          <h2 className='sections-heading'>Specify</h2>
          <RadioGroup
            labelId="cube-radio"
            items={[
              {
                id: "sideControl",
                name: "sideControl",
                label: "Side 'a'",
                className: 'usa-radio__input--tile',
                checked: vm.sideControl,
                onChange: vm.handleFormChange,
              },
              {
                id: 'diagonalControl',
                name: 'diagonalControl',
                label: 'Diagonal',
                className: 'usa-radio__input--tile',
                checked: vm.diagonalControl,
                onChange: vm.handleFormChange,
              },
            ]}
          />
          <h2 className='sections-heading'>General</h2>
          {vm.cubeControl === 1 ?
            <>
              <Input
                label="Side 'a'"
                idAndName="side"
                valid={!vm.formValidation.side}
                value={vm.cubeForm.side}
                className={vm.CubeErrorClass('side')}
                type="number"
                step={'0.01'}
                onChange={(e) => { vm.handleFormChange(e) }}
                onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
                onKeyDown={vm.handleOnKeyDown}
                min={0.01}
              />
              <Input
                label="Diagonal"
                idAndName="calculatedDiagonal"
                valid={true}
                value={vm.cubeForm?.diagonal ? vm.cubeForm?.diagonal: 0.00}
                className="calculated-result-box"
                type="string"
                onChange={() => { }}
                readOnly={true}
              />
            </>
            :
            <>
              <Input
                label="Diagonal"
                idAndName="diagonal"
                valid={!vm.formValidation.diagonal}
                value={vm.cubeForm.diagonal}
                className={vm.CubeErrorClass('diagonal')}
                type="number"
                step={'0.01'}
                min={0.01}
                onChange={vm.handleFormChange}
                onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
                onKeyDown={vm.handleOnKeyDown}
              />
              <Input
                label="Side 'a'"
                idAndName="calculatedSide"
                valid={true}
                value={vm.cubeForm?.side ? vm.cubeForm?.side : 0.00}
                className="calculated-result-box"
                type="string"
                onChange={() => { }}
                readOnly={true}
              />
            </>
          }
        </InputContainer >
        <div className="col formula-information " >
          {vm.hasResults ? (
            <div className="row formula-results ">
              <ResultsContainer>
                <div className="col-auto result-value-group">
                  <div className="row">
                    <div className="col-auto result-label">Volume (cu units):</div>
                    <div className="col-auto result-value">{vm.cubeResults.Volume}</div>
                  </div>
                  <div className="row">
                    <div className="col-auto result-label">Area (sq units):</div>
                    <div className="col-auto result-value">{vm.cubeResults.Area}</div>
                  </div>
                </div>
              </ResultsContainer>
            </div>
          ) : null}
          <div className="row formula-description">
            <DescriptionContainer>
              <p>
                {vm.formDescription}
                &nbsp;
                <a target="_blank" href={vm.bannerHelpLink}>
                  Learn More
                  <img src={pdfLogo} alt={'PDF logo'} />
                </a>
              </p>
            </DescriptionContainer>
          </div>
          <div className="row formula-images">

            <ImageContainer>
              <img
                className=""
                src={vm.image}
                alt={vm.hydraulicFormulaImageDescription}
                title={vm.formulaTitle}
              />
            </ImageContainer>
          </div>
        </div>
        {vm.isLoading && <Loader message={''} />}
      </div>
      <FormulaPrintModalContainer
        vm={vm}
        inputs={vm.exportedInputs}
        results={vm.exportedResults}
        images={[vm.image]}
        formulaName={vm.formulaTitle}
      />
    </Fragment>
  );
};

export const CubeFormula = observer(CubeComponent);